import React from "react";
import ReactECharts from "echarts-for-react";
import { Divider } from "@mui/material";
import CountUp from "react-countup";

const withLayoutFixes = (opt = {}) => {
  const hasTitle = !!opt.title && (Array.isArray(opt.title) ? opt.title.length > 0 : true);
  const legendTop = hasTitle ? 40 : 8;
  const gridTop = hasTitle ? 72 : 32;

  const getFirstTitle = () => {
    if (!opt.title) return opt.title;
    if (Array.isArray(opt.title)) {
      const t0 = opt.title[0] || {};
      return { top: 8, left: "center", itemGap: 6, ...t0 };
    }
    return { top: 8, left: "center", itemGap: 6, ...opt.title };
  };

  const patched = {
    ...opt,
    title: hasTitle ? getFirstTitle() : opt.title,
    legend: {
      top: legendTop,
      left: "center",
      type: "scroll",
      ...(opt.legend || {}),
    },
  };

  if (opt.xAxis || opt.yAxis) {
    patched.grid = {
      top: gridTop,
      left: 24,
      right: 24,
      bottom: 24,
      containLabel: true,
      ...(opt.grid || {}),
    };
  }

  if (opt.series) {
    const bumpSeries = (s) =>
      ["pie", "funnel", "radar", "gauge"].includes(s?.type || "")
        ? { top: gridTop, ...s }
        : s;

    patched.series = Array.isArray(opt.series)
      ? opt.series.map(bumpSeries)
      : bumpSeries(opt.series);
  }

  return patched;
};

const ChartAndTotals = ({ echartRef, chartData, totalsCount, safeTotalAmount, t }) => {
  return (
    <>
      <div className={`flex-[0.7] h-[400px]`}>
        <ReactECharts
          ref={echartRef}
          option={withLayoutFixes(chartData)}
          style={{ height: "100%", width: "100%" }}
          lazyUpdate={true}
          notMerge={true}
          autoResize={true}
        />
      </div>
      <div className="flex flex-col">
        <Divider orientation="vertical" />
      </div>
      <div className="flex flex-[0.3] flex-col justify-center items-center space-y-12">
        <div className="text-center">
          <div className="text-7xl font-extrabold [&>span]:bg-gradient-to-b [&>span]:from-[#1976d2] [&>span]:to-[#B1D4E0] [&>span]:bg-clip-text [&>span]:text-transparent">
            <CountUp end={Number(totalsCount || 0)} duration={1.2} separator="," />
          </div>
          <label className="mt-4 text-lg text-gray-600 mb-4">Transactions</label>
        </div>
        <div className="text-center">
          <div className="text-7xl font-extrabold [&>span]:bg-gradient-to-b [&>span]:from-[#1976d2] [&>span]:to-[#B1D4E0] [&>span]:bg-clip-text [&>span]:text-transparent">
            <CountUp end={Number(safeTotalAmount || 0)} duration={1.2} separator="," decimals={2} />
            <span>$</span>
          </div>
          <label className="mt-4 text-lg text-gray-600 mb-4">{t("collected_text")}</label>
        </div>
      </div>
    </>
  );
};

export default ChartAndTotals;
